module.exports = __webpack_public_path__ + "static/media/p_22_1.90b3bb65.png";